import { Component, Inject } from '@angular/core';
import { ISitemap, SITEMAP } from 'pbc.angular';
import { IFilterConfig, ISelection } from 'pbc.types';

import get from 'lodash/get';
import { Subscription } from 'rxjs';

import { IZeitResponse, ZeitQueryFilterConfig } from 'fa-kt.types';
import { ZeitService } from '../service';

@Component({
  selector: 'fa-kt-zeit-filter',
  templateUrl: './zeit-filter.component.html',
  styleUrls: ['./zeit-filter.component.css'],
})
export class ZeitFilterComponent {
  readonly subscriptions: Subscription[] = [];

  public ZeitFilterConfig: IFilterConfig<IZeitResponse>;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public zeit: ZeitService,
  ) {
    this.ZeitFilterConfig = ZeitQueryFilterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update mapper    */
    /*    update mapper >> */
  }

  ngOnInit() {
    this.subscriptions.push();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(($) => $.unsubscribe());
  }

  private shape(field: string, shapes: ISelection[]): void {
    const index = this.ZeitFilterConfig.findIndex((f) => f.key === field);
    if (index < 0) {
      return;
    }
    this.ZeitFilterConfig[index].selections = shapes;
  }
}
